// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'dev',
  siteUrl: 'https://alpha.reports.apac.gcds.coke.com',
  internalHost: 'api.reports.alpha.apac.gcds.coke.com',
  tenantId: '548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
  cognito: {
    userPoolId: 'ap-southeast-1_LcW3Ls1az',
    clientId: '5buo4u0r74kgtmaddfhgst7f9j',
    identityPoolId: 'ap-southeast-1:cabb1403-9ff6-438f-80c7-dc3a2d9aee23',
    region: 'ap-southeast-1',
    idpUrl: 'login.microsoftonline.com/548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
    azureAppId: 'af5baeee-b071-4a2f-a60d-a9bf426c841f',
  },
  cesAPI: {
    apiKey: 'LsyMBzOQp92BurOhdbffw5VEQltbPDtU7x9vkTuG'
  },
};